<template>
    <div class="w-100 mb-3">
                <span v-html="html"></span>
    </div>
</template>

<script>
export default {
    name: 'TikTokVideo',
    props: {
        html: {required: true},
    },
}
</script>
